import axios from "axios";
import utils from "../utils";

const getAllDietClasses = async () => {
  try {
    const response = await axios.get(`${utils.baseUrl}/diet_classes`);
    // console.log("diet_service.js - getAllDietClasses response:", response);

    if(response.status !== 200) {
      return {
        data: null,
        message: response.data.message
      }
    }
  
    return {
      data: response.data,
      message: response.data.message
    }
  } catch (error) {
    console.error(error)
  }
}

const deleteOneDietClass = async (diet_class_id) => {
  try {
    const response = await axios.delete(`${utils.baseUrl}/diet_classes/${diet_class_id}`);

    return {
      message: response.data.message,
      status: response.status
    }
  } catch (error) {
    return {
      message: error.response.data.message
    }
  }
}
const updateOneDietClass = async (diet_class_id, data) => {
  try {
    const response = await axios.patch(`${utils.baseUrl}/diet_classes/${diet_class_id}`, data);

    return {
      message: response.data.message,
      data: response.data.data,
      status: response.status
    }
  } catch (error) {
    return {
      message: error.response.data.message,
      status: error.response.status
    }
  }
}

const createOneDietClass = async (data) => {
  try {
    const response = await axios.post(`${utils.baseUrl}/diet_classes`, data);

    return {
      message: response.data.message,
      data: response.data.data,
      status: response.status
    }
  } catch (error) {
    return {
      message: error.response.data.message,
      status: error.response.status
    }
  }
}

const getOneDietClass = async (diet_class_id) => {
  try {
    const response = await axios.get(`${utils.baseUrl}/diet_classes/${diet_class_id}`);

    if(response.status !== 200) {
      return {
        data: null,
        message: response.data.message
      }
    }

    return {
      data: response.data,
      message: response.data.message
    }
  } catch (error) {
    console.error(error);
  }
}

// Diet Class Menu

const getAllDietClassMenus = async () => {
  try {
    const response = await axios.get(`${utils.baseUrl}/diet_class_menus`);
  
    if(response.status !== 200) {
      return {
        data: null,
        message: response.data.message
      }
    }
  
    return {
      data: response.data,
      message: response.data.message
    }
  } catch (error) {
    console.error(error)
  }
}

const deleteOneDietClassMenu = async (diet_class_menu_id) => {
  try {
    const response = await axios.delete(`${utils.baseUrl}/diet_class_menus/${diet_class_menu_id}`);

    return {
      message: response.data.message,
      status: response.status
    }
  } catch (error) {
    return {
      message: error.response.data.message
    }
  }
}

const updateOneDietClassMenu = async (diet_class_menu_id, data) => {
  try {
    const response = await axios.patch(`${utils.baseUrl}/diet_class_menus/${diet_class_menu_id}`, data);

    return {
      message: response.data.message,
      data: response.data.data,
      status: response.status
    }
  } catch (error) {
    return {
      message: error.response.data.message,
      status: error.response.status
    }
  }
}

const createOneDietClassMenu = async (data) => {
  try {
    const response = await axios.post(`${utils.baseUrl}/diet_class_menus`, data);

    return {
      message: response.data.message,
      data: response.data.data,
      status: response.status
    }
  } catch (error) {
    return {
      message: error.response.data.message,
      status: error.response.status
    }
  }
}

const getOneDietClassMenu = async (diet_class_menu_id) => {
  try {
    const response = await axios.get(`${utils.baseUrl}/diet_class_menus/${diet_class_menu_id}`);

    if(response.status !== 200) {
      return {
        data: null,
        message: response.data.message
      }
    }

    return {
      data: response.data,
      message: response.data.message
    }
  } catch (error) {
    console.error(error);
  }
}

const createOneMenu = async (data) => {
  const responseDietClassesMenu = await axios.post(`${utils.baseUrl}/diet_class_menus/`, data);
  return responseDietClassesMenu
}

const createDietWithMenu = async (dietData) => {
  try {
    const response = await axios.post(`${utils.baseUrl}/diet_classes/`, dietData);
    const data = await Promise.all(dietData.diet_class_menus.map( async menu => {
      const params = {
        name:menu.menu_name,
        calories:menu.calories,
        diet_class_id:response.data.data.id
      }
      return createOneMenu(params)
    }))
    console.log("diet_service.js - createDietWithMenu response:", response);

    return {
      message: response.data.message,
      status: response.status,
      data: response.data // include this
    }
  } catch (error) {
    console.log(error);
    return {
      message: error.message
    }
  }
}

const deleteClassMenusByClasses = async (id) => {
  const response = deleteOneDietClassMenu(id);
  return response
}

const deleteClasses = async (id) => {
  const oneDietClass = await getOneDietClass(id);
  const allDietClassMenu = await getAllDietClassMenus();

  const dietClassId = oneDietClass.data.id

  const data = await Promise.all(allDietClassMenu.data.map( async menu => {
    if(menu.diet_class_id === dietClassId){
      return deleteClassMenusByClasses(menu.id)
    }
    return;
  }))
}



const dietService = {
  // Diet Class
  getAllDietClasses,
  deleteOneDietClass,
  updateOneDietClass,
  createOneDietClass,
  getOneDietClass,
  createDietWithMenu,

  // Diet Class Menu
  getAllDietClassMenus,
  deleteOneDietClassMenu,
  updateOneDietClassMenu,
  createOneDietClassMenu,
  getOneDietClassMenu,
  deleteClassMenusByClasses,
  deleteClasses,
  createOneMenu,
}

export default dietService;
